<div class="buttons" #container [ngClass]="{ show: keep || focus || hover}" fxLayout="row wrap">
  <button type="button" class="option" mat-stroked-button *ngFor="let option of options" value="{{option}}"
    (click)="change(option)">
    {{option}}
  </button>
</div>
